import { sendRequestTaskEmail } from '../../../../../../api'
import { FILE_SCOPE_REQUEST } from '../../../../../../constants/file'
import { AITextGenerationLocalContextType } from '../../../../../AITextGeneration'
import {
  EMAIL_CREATION_FORM_TEMPLATE_FOLDER_REQUEST,
  getEmailAttachRequestExcludeRequestIds,
} from '../../../../../Email'
import { useRequestProfileContext } from '../../../../RequestProfile.hooks'
import {
  copyRequestEmailMessageToEntity,
  deleteRequestEmailMessage,
  deleteRequestEmailMessageCopiedEntity,
  getRequestEmailMessageFiles,
  resendRequestEmailMessage,
} from '../../../RequestProfileTabEmails.api'
import {
  getRequestEmailAttachProps,
  getRequestProfileCreateEmailPayload,
  getRequestTemplateEntityApiParams,
  getRequestTemplateListApiParams,
  getStandardFilterModalInitialValues,
} from '../../../RequestProfileTabEmailsCreateEmailPopUp'

export function useRequestProfileTabEmailsThreadModalMessageItemProps({
  audience,
  getPrintPageLink,
  getRawPageLink,
  isActionsDisabled = false,
  minimizedModalScope,
  requestId,
  onReloadList,
  onSuccessReply,
  onThreadRemoved,
}) {
  const requestProfileContext = useRequestProfileContext()

  const templateListApiParams = getRequestTemplateListApiParams({
    buildingId: requestProfileContext?.requestData?.building?.id,
    isAttachedRequestsMode: false,
  })

  const templateEntityApiParams = getRequestTemplateEntityApiParams({
    flatId: requestProfileContext?.requestData?.flat?.id,
    isAttachedRequestsMode: false,
    requestId,
  })

  return {
    PriorityFieldComponent: null,
    actionsConfig: {
      copyToApi: ({ data, uuid }) =>
        copyRequestEmailMessageToEntity({ data, requestId, uuid }).then(
          response => {
            onReloadList?.()

            return response
          }
        ),
      deleteCopiedEntityApi: ({ data, uuid }) =>
        deleteRequestEmailMessageCopiedEntity({ data, requestId, uuid }).then(
          response => {
            onReloadList?.()

            return response
          }
        ),
      deleteMessageApi: ({ id }) =>
        deleteRequestEmailMessage({ id, requestId }).then(response => {
          onReloadList?.()

          return response
        }),
      getExcludeIds: item => [
        ...getEmailAttachRequestExcludeRequestIds(item),
        requestId,
      ],
      getPrintPageLink,
      getRawPageLink,
      resendApi: uuid => resendRequestEmailMessage({ requestId, uuid }),
      shouldNavigateToList: false,
      onSuccessArchive: onThreadRemoved,
    },
    aiLocalContextObjectId: requestId,
    aiLocalContextType: AITextGenerationLocalContextType.ServiceRequestEmail,
    attachProps: getRequestEmailAttachProps({
      requestData: requestProfileContext?.requestData,
      requestId,
    }),
    bodyProps: {
      attachedFilesProps: {
        scope: FILE_SCOPE_REQUEST,
        subject: requestId,
      },
    },
    headerProps: {
      actionsProps: { disabled: isActionsDisabled },
      additionalInfoProps: {
        filePreviewProps: {
          scope: FILE_SCOPE_REQUEST,
          subject: requestId,
        },
        getFilesApi: async params =>
          getRequestEmailMessageFiles({
            ...params,
            outboundUuid: requestProfileContext?.outboundUuid,
            requestId,
          }),
      },
    },
    minimizedModalScope,
    recipientsFilterModalInitialValues: getStandardFilterModalInitialValues(
      requestProfileContext?.requestData
    ),
    replyConfig: {
      createMessageApi: ({ thread, ...payload }) =>
        sendRequestTaskEmail({
          data: {
            ...getRequestProfileCreateEmailPayload({ audience, payload }),
            request_thread: thread,
          },
          id: requestId,
        }),
      onSuccess: onSuccessReply,
    },
    singleTemplateFolder: EMAIL_CREATION_FORM_TEMPLATE_FOLDER_REQUEST,
    templateEntityApiParams,
    templateListApiParams,
    withServiceAccount: true,
  }
}
